import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, AfterContentInit, ChangeDetectorRef } from '@angular/core';

import { first, startWith, debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { AppService } from './../../appservice.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

import * as _moment from 'moment';
import { CurrencyPipe, TitleCasePipe } from '@angular/common';
import { Observable } from 'rxjs';
import { Suggestitem } from 'src/app/_models/suggestitem';
import { MatDialog } from '@angular/material';
import { NewItemComponent } from 'src/app/item/new-item/new-item.component';
import { NewCustomerComponent } from 'src/app/customer/new-customer/new-customer.component';
import { SuggestAccount } from 'src/app/_models/suggestaccount';
import { SuggestTax } from 'src/app/_models/suggesttax';
import { MessageBoxComponent } from 'src/app/shared/message-box/message-box.component';

const moment = _moment;

// https://momentjs.com/docs/#/displaying/format/
export const MY_FORMATS = {
  parse: {
    dateInput: 'D MMM YYYY',
  },
  display: {
    dateInput: 'D MMM YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'D MMM YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-new-invoice',
  templateUrl: './new-invoice.component.html',
  styleUrls: ['./new-invoice.component.css'],
  providers: [
    // `MomentDateAdapter` and `MAT_MOMENT_DATE_FORMATS` can be automatically provided by importing
    // `MatMomentDateModule` in your applications root module. We provide it at the component level
    // here, due to limitations of our example generation script.
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    CurrencyPipe,
    TitleCasePipe
  ]
})


export class NewInvoiceComponent implements OnInit, AfterContentInit {


  constructor(private _fb: FormBuilder, public service: AppService, private router: Router, public translate: TranslateService,
    private currencyPipe: CurrencyPipe, public dialog: MatDialog, private cdRef: ChangeDetectorRef) {
    this.invoiceForm = new FormGroup({
      CustomerName: new FormControl(),
      customerId: new FormControl(),
      name: new FormControl(),
      mobile: new FormControl(),
      phone: new FormControl(),
      address: new FormControl(),
      landmark: new FormControl(),
      pincode: new FormControl(),
      city: new FormControl(),
      state: new FormControl(),
      country: new FormControl(),
      gstin: new FormControl(),
      pan: new FormControl(),
      ordernumber: new FormControl(),
      date: new FormControl(moment()),
      buyorderno: new FormControl(),
      sname: new FormControl(),
      smobile: new FormControl(),
      sphone: new FormControl(),
      saddress: new FormControl(),
      slandmark: new FormControl(),
      spincode: new FormControl(),
      scity: new FormControl(),
      sstate: new FormControl(),
      scountry: new FormControl(),
      sgstin: new FormControl(),
      span: new FormControl(),
      salesorderitem: this._fb.array([this.getItem()]),
      sotax: this._fb.array([]),
      productqtytotal: new FormControl({ value: 0 }),
      subtotal: new FormControl({ value: 0 }),
      taxrate: new FormControl({ value: 0 }),
      dispatchdocno: new FormControl(),
      deliverynote: new FormControl(),
      transportmode: new FormControl(),
      vehicletype: new FormControl(),
      vehicleno: new FormControl(),
      dateofsupply: new FormControl(moment()),
      placeofsupply: new FormControl(service.dfPlaceOfSupply),
      tax_inc: new FormControl(this.isIncTax),
      terms: new FormControl(),
      charge: new FormControl(0),
      discount: new FormControl(0),
      totaltaxable: new FormControl({ value: 0 }),
      totaltax: new FormControl({ value: 0 }),
      grandtotal: new FormControl({ value: 0 }),
      istaxindividual: new FormControl(this.service.istaxindividual),
      taxtype: new FormControl(),
      rounding: new FormControl(this.service.rounding)
    });

  }

  get isTaxIndividual() {
    return this.service.istaxindividual;
  }

  get isIncTax() {
    return this.service.tax_inc;
  }


  maxDate = new Date();
  billdate = new Date();
  minDateofSupply = new Date();

  invoiceForm: FormGroup;

  example = { checked: false };
  isCharge = true;
  showhsncode = false;
  TaxRate = 12;
  totalSum = 0;
  nettotalSum = 0;
  totalSumQty = 0;
  totalSumDisc = 0;
  totalSumTax = 0;
  grandtotalSum = 0;
  isAddress = false;
  GrandTotalWords;
  name: string;
  animal: string;
  suggestitems: Observable<Suggestitem[]>;
  suggestaccount: Observable<SuggestAccount[]>;
  suggesttax: Observable<SuggestTax[]>;
  selectedItem: Suggestitem;
  selectedAccount: SuggestAccount;
  isEditMode = false;
  isSubmitting = false;
  maxitems = 100;
  taxGroup = 'CGST';

  @ViewChild('CustomerName', { static: true }) nameField: ElementRef;
  @ViewChild('ProductName', { static: true }) productnameField: ElementRef;
  @ViewChild('autoCust', { static: false }) customerAutocomplete: any;
  itemrowindex = 0;
  targetelement: any;
  isSetAutoFocus = false;
  private itemSelectionHandled: { [key: number]: boolean } = {};


  tabs = ['First', 'Second', 'Third'];
  selected = new FormControl(0);

  ngOnInit() {
    // initialize stream on units
    const myFormValueChanges$ = this.invoiceForm.controls['salesorderitem'].valueChanges;
    // subscribe to the stream so listen to changes on units
    myFormValueChanges$.subscribe(salesorderitem => this.updateTotalUnitPrice(salesorderitem));
    this.invoiceForm.controls.address.valueChanges.subscribe(x => this.addressskip());
    this.invoiceForm.controls.charge.valueChanges.subscribe(x => this.updateGrandTotal());

    // Always subscribe to discount if it's not individual, but handle the condition
    this.invoiceForm.controls.discount.valueChanges.
      subscribe(x => {
        if (!this.isTaxIndividual) {
          this.updateTotalUnitPrice(this.invoiceForm.controls['salesorderitem'].value);
        }
      });

    this.invoiceForm.controls.CustomerName.valueChanges.
      pipe(
        startWith(''),
        debounceTime(200),
        distinctUntilChanged()).subscribe(val => {
          this.suggestaccount = this.filterAccount(String(val));
          if (typeof val === 'string') {
            this.invoiceForm.controls.name.setValue(val);
            this.invoiceForm.controls.customerId.setValue(0);
          } else if (val && val.name) {
            this.invoiceForm.controls.name.setValue(val.name);
            this.invoiceForm.controls.customerId.setValue(val.id);
          }
        });

    // Force periodic sync check for first 10 seconds to handle slow server response
    const interval = setInterval(() => {
      if (this.service.isReady) {
        this.invoiceForm.get('istaxindividual').setValue(this.isTaxIndividual, { emitEvent: false });
        this.invoiceForm.get('tax_inc').setValue(this.isIncTax, { emitEvent: false });
        this.cdRef.detectChanges();
        clearInterval(interval);
      }
    }, 1000);
    setTimeout(() => clearInterval(interval), 10000);
  }

  ngAfterContentInit(): void {
    this.nameField.nativeElement.focus();
  }

  addTab(selectAfterAdding: boolean) {
    this.tabs.push('New');

    if (selectAfterAdding) {
      this.selected.setValue(this.tabs.length - 1);
    }
  }

  openDialog(index: number): boolean {
    const control = <FormArray>this.invoiceForm.controls['salesorderitem'];
    const val = control.at(index).get('ProductName').value;
    const dialogRef = this.dialog.open(NewItemComponent, {
      width: '600px',
      data: {
        name: (val != null && val.name != null) ? val.name : val,
        id: control.at(index).get('itemId').value
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.setitemdetails(control, index, result);
        control.at(index).get('ProductName').patchValue(result);
        // control.at(this.itemrowindex).get("name").patchValue(result.name);
        this.targetelement.focus();
      }
    });
    return false;
  }

  openDescDialog(index: number): boolean {
    const control = <FormArray>this.invoiceForm.controls['salesorderitem'];
    const val = control.at(index).get('note').value;
    try {
      this.isSubmitting = true;

      const dialogRef = this.dialog.open(MessageBoxComponent, {
        width: '350px', data: {
          title: 'Add Note',
          message: 'Invoice.ItemNote',
          input: 'Note',
          inputtype: 'text',
          value: val
        }
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          control.at(index).get('note').patchValue(result);
          // control.at(this.itemrowindex).get("name").patchValue(result.name);
          // this.targetelement.focus();
        }
      });
    } catch (ex) {
      console.log(ex);
      this.service.sendMessage('Oops');
    } finally {
      this.isSubmitting = false;
    }

    return false;
  }

  updateDate() {
    this.minDateofSupply = this.invoiceForm.controls.date.value;
    this.invoiceForm.controls.dateofsupply.patchValue(this.minDateofSupply);
  }

  isCustdialogOpened = false;

  onEditCustomerClick(): void {
    // Safari fix: Close autocomplete panel explicitly before opening dialog
    if (this.customerAutocomplete && this.customerAutocomplete.closePanel) {
      this.customerAutocomplete.closePanel();
    }

    // Small delay to ensure panel is closed
    setTimeout(() => {
      this.autoFillCustDetails();
    }, 100);
  }

  openCustDialog(): boolean {
    // Safari fix: Close autocomplete panel before opening dialog
    if (this.customerAutocomplete && this.customerAutocomplete.closePanel) {
      this.customerAutocomplete.closePanel();
    }

    // Get customer value and safely extract name and id
    const custValue = this.invoiceForm.controls.CustomerName.value;
    let custName = '';
    let custId = 0;

    if (custValue) {
      if (typeof custValue === 'string') {
        custName = custValue;
        custId = 0;
      } else if (custValue.name) {
        custName = custValue.name;
        custId = custValue.id || 0;
      }
    }

    const dialogRef = this.dialog.open(NewCustomerComponent, {
      width: '600px',
      data: {
        name: custName,
        id: custId
      }
    });
    this.isCustdialogOpened = true;

    dialogRef.afterClosed().subscribe(result => {
      // Dialog closed – always clear the "dialog open" flag
      this.isCustdialogOpened = false;

      // Safari fix: Use longer delay and ensure autocomplete is fully closed
      setTimeout(() => {
        if (result && result.id && result.id !== 0) {
          // Valid new/edited customer – update form and load details
          this.invoiceForm.controls.CustomerName.patchValue(result);
          this.invoiceForm.controls.name.patchValue(result.name);
          this.invoiceForm.controls.customerId.patchValue(result.id);

          // Close autocomplete panel explicitly
          if (this.customerAutocomplete && this.customerAutocomplete.closePanel) {
            this.customerAutocomplete.closePanel();
          }

          // Refocus customer name field
          if (this.nameField && this.nameField.nativeElement) {
            this.nameField.nativeElement.focus();
          }

          // Load customer details
          this.autoFillCustDetails();
        } else {
          // User clicked "No thanks" or invalid result
          // Close autocomplete panel explicitly
          if (this.customerAutocomplete && this.customerAutocomplete.closePanel) {
            this.customerAutocomplete.closePanel();
          }

          // Keep focus on customer name
          if (this.nameField && this.nameField.nativeElement) {
            this.nameField.nativeElement.focus();
          }
        }
      }, 250); // Increased delay for Safari
    });

    return false;
  }

  /**
   * Create form items
   */
  private getItem() {
    const numberPatern = '^[0-9.,]+$';
    const fg = this._fb.group({
      ProductName: ['', Validators.required],
      itemId: [''],
      name: ['', Validators.required],
      code: [''],
      description: [''],
      note: [''],
      itemgroup: [''],
      hnscode: [''],
      qty: [1, [Validators.required, Validators.pattern(numberPatern)]],
      rate: ['', [Validators.required, Validators.pattern(numberPatern)]],
      charge: [0],
      discount: [0],
      taxrate: [this.TaxRate, [Validators.required, Validators.pattern(numberPatern)]],
      unitD: ['PCS'],
      unit: ['PCS', Validators.required],
      warranty: [''],
      itemtypeId: [1, Validators.required],
      tax: [0],
      taxgrouptype: [this.service.df_taxgroup],
      taxableamt: [0],
      netamount: [0],
      productsubtotal: [0],
      totalD: [0],
      total: [0, Validators.required],
      sotax: this._fb.array([])
    });
    fg.controls.unitD.disable({ onlySelf: true, emitEvent: true });
    fg.controls.warranty.disable({ onlySelf: true, emitEvent: true });
    fg.controls.totalD.disable({ onlySelf: true, emitEvent: true });
    // fg.controls.taxrate.disable({ onlySelf: true, emitEvent: true });

    fg.controls['ProductName'].valueChanges.
      pipe(
        debounceTime(200),
        distinctUntilChanged()).subscribe(val => {
          this.suggestitems = this.filter(String(val));
          if (typeof val === 'string') {
            fg.controls['name'].setValue(val);
            fg.controls['itemId'].setValue('');
          } else if (val && val.name) {
            fg.controls['name'].setValue(val.name);
            fg.controls['itemId'].setValue(val.id);
          }
        });

    return fg;
  }


  /**
   * Create form items
   */
  private getSoTaxItem(element: SuggestTax, pid: number = 0, index = 0) {
    const numberPatern = '^[0-9.,]+$';
    const fg = this._fb.group({
      name: [element.name, Validators.required],
      taxgroup: [element.group, Validators.required],
      type: [element.group],
      rate: [parseFloat(element.rate.toString()), [Validators.required, Validators.pattern(numberPatern)]],
      taxableamt: [this.nettotalSum, [Validators.required, Validators.pattern(numberPatern)]],
      amount: [(this.nettotalSum * element.rate / 100), [Validators.required, Validators.pattern(numberPatern)]],
      itemId: [pid === 0 ? null : pid],
      itemIndex: [index]
    });
    // fg.controls.name.disable({ onlySelf: true, emitEvent: true });
    // fg.controls.rate.disable({ onlySelf: true, emitEvent: true });
    // fg.controls.amount.disable({ onlySelf: true, emitEvent: true });
    return fg;
  }

  /**
   * Add new unit row into form
   */
  private addItem() {
    if (!this.isSubmitting && this.maxitems > 0) {
      this.maxitems = this.maxitems - 1;
      const control = <FormArray>this.invoiceForm.controls['salesorderitem'];
      control.push(this.getItem());
    } else if (this.maxitems <= 0) {
      this.service.sendMessage('Maximum no of items are reached please create another invice for rest of items');
    }
  }

  /**
   * Remove unit row from form on click delete button
   */
  private removeItem(i: number) {
    const control = <FormArray>this.invoiceForm.controls['salesorderitem'];
    control.removeAt(i);
  }

  /**
   * Update prices as soon as something changed on units group
   */
  private updateTotalUnitPrice(units: any) {
    // get our units group controll
    const control = this.salesItems;
    // before recount total price need to be reset.
    this.totalSum = 0;
    this.totalSumQty = 0;
    this.totalSumTax = 0;
    this.totalSumDisc = 0;
    this.nettotalSum = 0;
    let blanknames = 0;
    let blankindex = 0;
    for (const i of Object.keys(units)) {
      const pname = units[i].ProductName.name ? units[i].ProductName.name : units[i].ProductName;
      if (pname === '' || pname == null) {
        blanknames++;
        blankindex = +i;
        continue;
      }
      let totalUnitPrice = (this.parseNumber(units[i].qty) * this.parseNumber(units[i].rate)) - this.parseNumber(units[i].discount);
      let taxamt = 0.0;
      if (this.isTaxIndividual) {
        if (this.isIncTax) {
          taxamt = totalUnitPrice * (this.parseNumber(units[i].taxrate) / (100.00 + this.parseNumber(units[i].taxrate)));
        } else {
          taxamt = totalUnitPrice * this.parseNumber(units[i].taxrate) / 100.00;
          totalUnitPrice = totalUnitPrice + taxamt;
        }
        // Tax calculatio at individual level
        const tcontrol = <FormArray>(<FormArray>(<FormArray>this.invoiceForm.controls['salesorderitem']).controls[+i]).controls['sotax'];
        for (let t = 0; t < tcontrol.length; t++) {
          const irate = tcontrol.controls[t].value.rate;
          let itaxamt = 0;
          const itotalUnitPrice = totalUnitPrice - taxamt;
          itaxamt = itotalUnitPrice * this.parseNumber(irate) / 100.00;
          tcontrol.at(t).value.taxableamt = itotalUnitPrice;
          tcontrol.at(t).value.amount = itaxamt;
        }
      }
      // now format total price with angular currency pipe
      const totalUnitPriceFormatted = this.currencyPipe.transform(totalUnitPrice, this.service.currency, 'symbol-narrow', '1.2-2');
      // update total sum field on unit and do not emit event myFormValueChanges$ in this case on units
      control.at(+i).get('totalD').patchValue(totalUnitPriceFormatted, { onlySelf: true, emitEvent: false });
      control.at(+i).get('total').patchValue(totalUnitPrice, { onlySelf: true, emitEvent: false });
      control.at(+i).get('productsubtotal').patchValue(totalUnitPrice, { onlySelf: true, emitEvent: false });
      control.at(+i).get('tax').patchValue(taxamt, { onlySelf: true, emitEvent: false });
      control.at(+i).get('taxableamt').patchValue(totalUnitPrice - taxamt, { onlySelf: true, emitEvent: false });
      control.at(+i).get('netamount').patchValue(totalUnitPrice, { onlySelf: true, emitEvent: false });
      // update total price for all units
      if (this.isTaxIndividual) {
        this.totalSumDisc += this.parseNumber(units[i].discount);
      }
      this.totalSum += totalUnitPrice;
      if (units[i].itemtypeId === 1) {
        this.totalSumQty += units[i].qty;
      }
      this.totalSumTax += taxamt;
      this.nettotalSum += totalUnitPrice;
    }

    this.updateGrandTotal();
    // if (blanknames === 0) {
    //   this.addItem();
    // } else if (blanknames >= 2) {
    //   this.removeItem(blankindex);
    // }



    // ⛔ Stop auto logic while customer is loading
    // if (this.isCustomerLoading) {
    //   return;
    // }

    // 🛑 NEVER allow empty FormArray
    if (control.length === 0) {
      control.push(this.getItem());
      return;
    }

    // ➕ Add new row ONLY if last row is filled
    const lastItem = units[units.length - 1];

    // Only add a new row if:
    if (
      lastItem &&
      lastItem.ProductName &&
      (
        lastItem.itemId ||                      // 1. An item from the list was selected
        typeof lastItem.ProductName === 'object' || // 2. (Same as above)
        (this.parseNumber(lastItem.rate) > 0)    // 3. OR you typed a name AND gave it a price
      )
    ) {
      this.addItem();
    }


  }

  updateGrandTotal() {
    // console.log(this.invoiceForm.controls['sotax']);

    if (this.isTaxIndividual) {
      this.invoiceForm.controls.discount.patchValue(this.totalSumDisc, { emitEvent: false, onlySelf: true });
      this.nettotalSum = this.totalSum - this.totalSumTax;
    } else {
      this.totalSumDisc = this.parseNumber(this.invoiceForm.controls.discount.value);
      this.nettotalSum = this.totalSum - this.totalSumDisc;
      if (this.isIncTax) {
        this.totalSumTax = this.nettotalSum * (this.parseNumber(this.TaxRate) / (100.00 + this.parseNumber(this.TaxRate)));
        this.nettotalSum = this.nettotalSum - this.totalSumTax;
      } else {
        this.totalSumTax = (this.nettotalSum * this.TaxRate) / 100;
        // this.totalSum = this.nettotalSum + this.totalSumTax;
      }
    }
    // this.invoiceForm.controls.totaltax.setValue(this.currencyPipe.transform(this.totalSumTax, this.service.currency,
    // 'symbol-narrow', '1.2-2'));
    this.grandtotalSum = this.nettotalSum + this.totalSumTax;
    this.grandtotalSum = this.service.rounding ? Math.round(this.grandtotalSum) : this.grandtotalSum;
    this.GrandTotalWords = this.service.toWords(this.grandtotalSum);

    this.invoiceForm.controls.subtotal.patchValue(this.totalSum, { emitEvent: false, onlySelf: true });
    this.invoiceForm.controls.productqtytotal.patchValue(this.totalSumQty, { emitEvent: false, onlySelf: true });
    this.invoiceForm.controls.totaltaxable.patchValue(this.nettotalSum, { emitEvent: false, onlySelf: true });
    this.invoiceForm.controls.totaltax.patchValue(this.totalSumTax, { emitEvent: false, onlySelf: true });
    if (!this.isTaxIndividual) {
      this.invoiceForm.controls.taxrate.patchValue(this.TaxRate, { emitEvent: false, onlySelf: true });
    }
    this.invoiceForm.controls.grandtotal.patchValue(this.grandtotalSum, { emitEvent: false, onlySelf: true });
    this.invoiceForm.controls.discount.patchValue(this.totalSumDisc, { emitEvent: false, onlySelf: true });

    this.updateTaxDetails();
  }

  addressskip() {
    if (this.invoiceForm.controls.address.value == null || this.invoiceForm.controls.address.value === '') {
      this.isAddress = false;
    } else {
      this.isAddress = true;
    }
    if (this.productnameField && this.productnameField.nativeElement) {
      this.productnameField.nativeElement.focus();
    }
  }

  clearItem(index, event) {
    if (this.isCustomerLoading) {
      return;
    }
    // Check if blur is caused by clicking on autocomplete option
    const relatedTarget = (event as any).relatedTarget as HTMLElement | null;
    if (relatedTarget) {
      // Check if the relatedTarget is within the autocomplete panel
      const autocompletePanel = document.querySelector('.cdk-overlay-pane .mat-autocomplete-panel');
      if (autocompletePanel && (autocompletePanel.contains(relatedTarget) || relatedTarget.closest('.mat-autocomplete-panel'))) {
        // Blur is from clicking on autocomplete, skip processing
        return;
      }

      // If blur is caused by clicking on the line item's icon buttons (edit / note),
      // skip auto logic here – the button's own (click) handler will open the dialog.
      const iconButton = relatedTarget.closest('button[mat-icon-button]');
      if (iconButton) {
        return;
      }
    }

    // Check if item selection was already handled by optionSelected
    if (this.itemSelectionHandled[index]) {
      this.itemSelectionHandled[index] = false;
      return;
    }

    this.targetelement = event.target || event.srcElement || event.currentTarget;
    const control = <FormArray>this.invoiceForm.controls['salesorderitem'];

    // Small delay to allow autocomplete to update value if optionSelected didn't fire
    setTimeout(() => {
      const val = control.at(index).get('ProductName').value;

      // Check if value is a string (typed text) or an object (selected item)
      if ((val == null || val === '') && !this.isCustomerLoading) {
        this.removeItem(index);
      }
      else if (typeof val === 'object' && (!val.name || val.name === '')) {
        // Value is an invalid object - open create dialog
        this.itemrowindex = index;
        this.name = '';
        this.openDialog(index);
      } else if (val.name && val.id) {
        // Valid item object - set details
        this.setitemdetails(control, index, val);
      }
    }, 100);
  }

  onItemSelected(index: number, event: any) {
    const selectedItem = event.option.value;
    if (selectedItem && selectedItem.name && selectedItem.id) {
      // Mark that selection is handled to prevent blur from processing
      this.itemSelectionHandled[index] = true;
      const control = <FormArray>this.invoiceForm.controls['salesorderitem'];
      setTimeout(() => {
        this.setitemdetails(control, index, selectedItem);

        // force recalculation AFTER details are set
        this.updateTotalUnitPrice(this.salesItems.value);
      }, 0);

    }
  }


  private setitemdetails(control: FormArray, index: any, val: any) {
    if (val.name === control.at(index).get('name').value && control.at(index).get('itemId').value === val.id) {
      return;
    }
    control.at(index).get('rate').patchValue(val.rate);
    control.at(index).get('hnscode').patchValue(val.hsncode);
    control.at(index).get('unitD').patchValue(val.itemunit.unitname);
    control.at(index).get('unit').patchValue(val.itemunit.unitname);
    control.at(index).get('warranty').patchValue(val.warranty != null && val.warranty !== undefined && val.warranty !== '' ? (val.warranty + ' days') : '-');
    control.at(index).get('itemtypeId').patchValue(val.itemtypeId);
    control.at(index).get('name').patchValue(val.name);
    control.at(index).get('code').patchValue(val.code);
    control.at(index).get('description').patchValue(val.description);
    control.at(index).get('itemgroup').patchValue(val.itemgroup);
    control.at(index).get('charge').patchValue(val.charge);
    control.at(index).get('discount').patchValue(val.discount == null ? 0 : val.discount);
    control.at(index).get('itemId').patchValue(val.id);
    if (this.isTaxIndividual) {
      const taxes = this.getTaxdetails(val.taxgroup, val.id, index);
      let sumTax = 0.0;
      taxes.forEach(e => {
        sumTax += parseFloat(e.rate);
      });
      console.log(sumTax);
      control.at(index).get('taxrate').patchValue(sumTax);
    }
  }

  autoFillCustDetails() {
    const val = this.invoiceForm.controls.CustomerName.value;

    // Safari fix: Don't process if dialog is open or just closed
    if (this.isCustdialogOpened) {
      return;
    }

    // If empty value, open dialog for new customer (same as item name behavior)
    if (!val || val === '') {
      this.openCustDialog();
      return;
    }

    if (typeof val === 'string') {
      // If it's a string (typed) and no customerId, it means they want a new/custom customer
      // We sync the name but only open the dialog if they specifically clicked the edit button.
      this.invoiceForm.controls.name.patchValue(val);
      this.invoiceForm.controls.customerId.patchValue(0);

      // Since this is often called by the edit button or manual check,
      // if itemId is 0, we open the dialog to let them formalize it.
      if (this.invoiceForm.controls.customerId.value == 0 || this.invoiceForm.controls.customerId.value == null) {
        this.openCustDialog();
      }
    } else if (val != null && val.id == null) {
      if (this.invoiceForm.controls.customerId.value == 0 || this.invoiceForm.controls.customerId.value == null) {
        this.openCustDialog();
      }
    } else {
      this.isCustomerLoading = true;

      this.service.getRequest('api/customers/' + val.id).subscribe(x => {

        if (x == null || x.id == null || x.id === 0) {
          this.openCustDialog();
          return;
        }
        this.invoiceForm.controls.address.patchValue(x.address);
        this.invoiceForm.controls.pincode.patchValue(x.pincode);
        this.invoiceForm.controls.mobile.patchValue(x.mobile);
        this.invoiceForm.controls.phone.patchValue(x.phone);
        this.invoiceForm.controls.landmark.patchValue(x.landmark);
        this.invoiceForm.controls.city.patchValue(x.city);
        this.invoiceForm.controls.state.patchValue(x.state);
        this.invoiceForm.controls.country.patchValue(x.country);
        this.invoiceForm.controls.gstin.patchValue(x.gstin);
        this.invoiceForm.controls.pan.patchValue(x.pan);
        this.invoiceForm.controls.name.patchValue(x.name);
        this.invoiceForm.controls.customerId.patchValue(x.id);

        this.invoiceForm.controls.saddress.patchValue(x.address);
        this.invoiceForm.controls.spincode.patchValue(x.pincode);
        this.invoiceForm.controls.smobile.patchValue(x.mobile);
        this.invoiceForm.controls.sphone.patchValue(x.phone);
        this.invoiceForm.controls.slandmark.patchValue(x.landmark);
        this.invoiceForm.controls.scity.patchValue(x.city);
        this.invoiceForm.controls.sstate.patchValue(x.state);
        this.invoiceForm.controls.scountry.patchValue(x.country);
        this.invoiceForm.controls.sgstin.patchValue(x.gstin);
        this.invoiceForm.controls.span.patchValue(x.pan);
        this.invoiceForm.controls.sname.patchValue(x.name);

        const control = <FormArray>this.invoiceForm.controls['sotax'];
        this.clearFormArray(control);
        // control.reset();
        if (this.invoiceForm.controls.state.value.toLowerCase() === this.service.df_state.toLowerCase()) {
          this.taxGroup = 'CGST';
        } else {
          this.taxGroup = 'IGST';
        }
        this.getTaxdetails(this.service.df_taxgroup);

        // Safari fix: Don't auto-focus to product name if dialog operations are happening
        if (!this.isCustdialogOpened) {
          setTimeout(() => {
            if (this.productnameField && this.productnameField.nativeElement) {
              this.productnameField.nativeElement.focus();
            }
            this.isSetAutoFocus = true;
          }, 200);
        }

        this.isCustomerLoading = false;
      });
    }
  }

  get salesItems(): FormArray {
    return this.invoiceForm.get('salesorderitem') as FormArray;
  }

  trackByIndex(index: number): number {
    return index;
  }

  isCustomerLoading = false;


  getTaxdetails(taxslab: string, pid: number = 0, index = 0): any {
    const taxes = this.service.taxes.filter(x => {
      return x.group === this.taxGroup && x.type === taxslab;
    });
    let control: FormArray;
    const soItems = this.invoiceForm.get('salesorderitem') as FormArray;

    if (this.isTaxIndividual) {
      if (soItems && soItems.length > index) {
        const itemGroup = soItems.at(index) as FormGroup;
        control = itemGroup.get('sotax') as FormArray;
      } else {
        return [];
      }
    } else {
      control = this.invoiceForm.get('sotax') as FormArray;
    }

    if (!control) return [];
    let sumTax = 0.0;
    this.clearFormArray(control);
    taxes.forEach(element => {
      control.push(this.getSoTaxItem(element, pid, index));
      sumTax += parseFloat(element.rate);
    });
    this.TaxRate = sumTax;
    return taxes;
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  }
  updateTaxDetails() {
    this.invoiceForm.controls['sotax'].value.forEach(element => {
      // console.log("sd rate" + element.rate);
      // console.log(element);
      element.amount = this.nettotalSum * element.rate / 100;
      element.taxableamt = this.nettotalSum;
    });
  }

  onSubmit() {
    console.log(this.invoiceForm);
    this.isSubmitting = true;
    try {
      const i2remove = [];
      let i = 0;
      this.invoiceForm.controls['salesorderitem'].value.forEach(element => {
        if (element.ProductName == null || element.ProductName === '') {
          i2remove.push(i);
        }
        i++;
      });

      i2remove.forEach(x => {
        const control = <FormArray>this.invoiceForm.controls['salesorderitem'];
        //// console.log('removing :' + x);
        control.removeAt(x);
      });

      if (this.isTaxIndividual) {
        const taxcontrol = <FormArray>this.invoiceForm.controls['sotax'];
        taxcontrol.controls.forEach(element => {
          if (element.value.itemIndex === i) {
            taxcontrol.removeAt(taxcontrol.controls.findIndex(element.value));
          }
        });
        this.invoiceForm.value.taxrate = null;
      }

      this.invoiceForm.value.taxtype = this.taxGroup;

      if (this.invoiceForm.valid) {
        this.service.getRequestData('api/invoices', this.invoiceForm.value).subscribe((data) => {
          // console.log(data);
          if (data.Success) {
            this.service.sendMessage('Invoice.SaveSuccess');
            this.router.navigate(['/invoice/view/', data.id]);
          } else {
            this.service.sendMessage('Invoice.CreateFailedRetry');
          }
        },
          (err) => {
            // console.log("Item creation failed : " + err);
            this.service.sendMessage('Oops');
          });
      } else {
        // console.log(this.invoiceForm);
        let dirtyctls = '';
        this.findInvalidControls().forEach(x => {
          dirtyctls += x + ',';
        });
        dirtyctls = dirtyctls.length > 0 ? dirtyctls.substring(0, dirtyctls.length - 1) : '';
        this.service.sendMessage('Invalid details , Please check :' + dirtyctls);
        // this.service.sendMessage('Invoice.FillAllDetails');
      }
    } catch (e) {
      // console.log('invoice gen error :' + e);
      this.service.sendMessage('Invoice.CreateFailedRetry');
    }
    finally {
      this.isSubmitting = false;
    }
  }

  handleEnterKeyPress(event) {
    const tagName = event.target.tagName.toLowerCase();
    if (tagName !== 'textarea' && tagName !== 'button') {
      return false;
    }
  }

  displayFn(item: Suggestitem): string {
    this.selectedItem = item;
    return item ? item.name : (item && item.id ? item.id.toString() : null);
  }

  displayFnCust(item: SuggestAccount): string {
    this.selectedAccount = item;
    return item ? item.name : (item && item.id ? item.id.toString() : null);
  }

  parseNumber(num: any): number {
    const n = parseFloat(num);
    return isNaN(n) ? 0 : n;
  }


  public findInvalidControls() {
    const invalid = [];
    const controls = this.invoiceForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  filter(val: String): Observable<any[]> {
    if (val) {
      return this.service.getRequest('api/items/suggest?search=' + val)
        .pipe(
          map(response => response)
        );
    }
  }

  filterAccount(val: String): Observable<any[]> {
    if (val) {
      return this.service.getRequest('api/customers/suggest?search=' + val)
        .pipe(
          map(response => response)
        );
    }
  }

  scrollTo(element) {
    element.scrollIntoView({ behavior: 'smooth' });
    // element.scrollto
    // element.scrollTop = element.scrollHeight - element.clientHeight;
  }

  keytab(target) {
    var element = document.querySelector("input[formControlName='" + target + "']") as HTMLInputElement;
    if (element != null) {
      element.focus();
      element.select();
    }
  }

  keytabCustomerName(target) {
    var element = document.querySelector("input[formControlName='" + target + "']") as HTMLInputElement;
    if (element != null) {
      if (this.invoiceForm.controls.customerId.value == 0) {
        this.openDescDialog(0);
      } else {
        element.focus();
        element.select();
      }
    }
  }

  keytabTextArea(target) {
    var element = document.querySelector("input[formControlName='" + target + "']") as HTMLTextAreaElement;
    if (element != null) {
      element.focus();
      element.select();
    }
  }

  keytabLineItem(target, index) {
    try {
      var element = document.querySelectorAll("input[formControlName='" + target + "']")[index] as HTMLInputElement;
      if (element != null) {
        element.focus();
        element.select();
      }
    } catch (error) {

    }
  }

  keytabProductName(event, index) {
    try {
      if (!this.isSetAutoFocus) {
        var element = document.querySelectorAll("input[formControlName='ProductName']")[index] as HTMLInputElement;
        if (element != null && element.value == '') {
          var element1 = document.querySelector("input[formControlName='dispatchdocno']") as HTMLInputElement;
          element1.focus();
        } else {
          var element1 = document.querySelectorAll("input[formControlName='qty']")[index] as HTMLInputElement;
          element1.focus();
        }
      } else {
        this.isSetAutoFocus = false;
      }
    } catch (error) {

    }
  }

  keytabToItemName(index) {
    //const control = <FormArray>this.invoiceForm.controls['salesorderitem'];
    try {
      var element = document.querySelectorAll("input[formControlName='ProductName']")[index + 1] as HTMLInputElement;
      if (element != null)
        element.focus();
    } catch (error) {

    }
  }

  refreshpage() {
    this.router.navigateByUrl('/invoice/0', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/invoice/0']);
    });
    return true;
  }

}